<div class="excel-upload-zone" [class.dragging]="isDragging">
  
  <label class="upload-content" for="file-input">
    <ng-content select="top-content"></ng-content>

    <div class="upload-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="12" y1="18" x2="12" y2="12"></line>
        <line x1="9" y1="15" x2="15" y2="15"></line>
      </svg>
    </div>
    
    <h3>Drop File Here</h3>
    <p>or</p>
    
    <h4>Click to Browse...</h4>
    <input class="file-input" id="file-input" type="file" [accept]="allowedExtensions" (change)="handleFileInput($event)">
    
    <p class="file-types">Supported File Types: {{allowedExtensions.join(', ')}}</p>
  </label>
</div>